<template>
  <div>
    <!-- AccountInfoForm.vue와 통일성 유지 필요 -->
    <div class="title-bar back-title">
      <i class="el-icon-back c-pointer mr-r4" @click="clickBackButton"></i> 비밀번호 변경
    </div>
    <el-form :model="passwordObject" label-position="top" :rules="rules" ref="passwordForm">
      <div class="mr-b15">
        <el-form-item label="관리자 비밀번호" prop="adminPassword">
          <el-input type="password" v-model="passwordObject.adminPassword"></el-input>
        </el-form-item>
      </div>
      <div class="mr-b15">
        <el-form-item label="변경된 비밀번호" prop="newPassword">
          <el-input type="password" v-model="passwordObject.newPassword"></el-input>
        </el-form-item>
      </div>
      <div class="mr-b15">
        <el-form-item label="변경된 비밀번호 확인" prop="newPasswordConfirm">
          <el-input type="password" v-model="passwordObject.newPasswordConfirm"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button size="large" class="mr-r4" type="solid" @click="clickInitPasswordButton">변경</el-button>
      <el-button size="large" @click="clickBackButton">취소</el-button>
    </el-row>
  </div>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import msgUtil from '@/utils/message';
import { validatePassword } from '@/utils/string';
import UserSettingAPI from '@/api/settings/user/user-setting';
import rsaEncrypt from '@/utils/rsa-encrypt';

export default {
  name: 'WChangePassword',
  props: {
    selectedUserInfo: Object,
    policy: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      passwordObject: {
        adminPassword: null,
        newPassword: null,
        newPasswordConfirm: null,
      },
      rules: {
        adminPassword: {
          required: true,
          validator: this.validateAdminPassword,
          trigger: 'blur',
        },
        newPassword: {
          required: true,
          validator: this.validatePassword,
          trigger: 'blur',
        },
        newPasswordConfirm: {
          required: true,
          validator: this.validateNewPasswordConfirm,
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    clickBackButton() {
      this.$emit('click-back-button');
    },
    clickInitPasswordButton() {
      const fieldData = {
        managerId: this.selectedUserInfo.managerId,
        password: this.passwordObject.newPassword,
      };
      this.$refs.passwordForm.validate().then(() => {
        rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
          const target = '비밀번호';
          const params = {
            managerId: encryData.managerId,
            password: encryData.password,
          };
          UserSettingAPI.changePassword(params).then(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, true));
            this.clickBackButton();
          });
        });
      }).catch(() => {});
    },
    validateAdminPassword(rule, value, callback) {
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('관리자 비밀번호를 입력해주세요.'));
      } else {
        const fieldData = {
          password: this.passwordObject.adminPassword,
        };
        rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
          const params = {
            password: encryData.password,
          };
          UserSettingAPI.checkAdminPassword(params).then((response) => {
            if (response.data.data) {
              callback();
            } else {
              callback(new Error('관리자 비밀번호가 맞지 않습니다.'));
            }
          });
        });
      }
    },
    validateNewPasswordConfirm(rule, value, callback) {
      if (isNil(value) || value.length <= 0) {
        callback(new Error('비밀번호를 입력해주세요.'));
      } else {
        const password = this.passwordObject.newPassword;
        if (isNil(password) || password.length <= 0) {
          callback(new Error('비밀번호를 입력해주세요.'));
        }
        if (!isEqual(value, password)) {
          callback(new Error('비밀번호가 일치하지 않습니다.'));
        }
      }
      callback();
    },
    /**
     * 패스워드 정책에 맞는 유효성검사를 한다.
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     * @author jda
     */
    validatePassword(rule, value, callback) {
      const result = validatePassword(value, this.policy, this.selectedUserInfo);
      if (result.valid) {
        callback();
      } else {
        callback(new Error(result.message));
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/components/ChangePassword.vue